define([
	"dojo/_base/declare",
	"csi/def/Actions"
], function(declare,Actions) {

	return declare(null, {
		// summary: container holding information used to create popup view
		constructor: function(/*Controller*/ac, /*csi.def.View*/defView, /*Node?*/node) {
			this.m_ac = ac;
			this.m_defView = defView;
			this.m_node = node;

			if (defView) {
				defView.setFormData(ac.getFormData());

				// populate actions for popup view - derived controllers can define addProxyActions to add their own actions
				var defActions = new Actions();
				ac.addProxyActions(defView, defActions);

				// assign actions to the view AFTER we are done with creating proxy actions and reassigning existing actions;
				// the call to addProxyActions may refer to the existing m_defActions
				defView.m_defActions = defActions;
			}
		}
	});
});
